import React from 'react';
import './TenderAccess.css';

// Import the new image
import tenderImage from '../../assets/images/tender-details.png';

const TenderAccess = () => {
  return (
    <section className="tender-access-section">
      <div className="tender-access-container">
        {/* Left Column: Text Content */}
        <div className="tender-access-text-col">
          <h2>Live Notifications access with detailed information</h2>
          <p>
            CRISHI gives you live access to Notifications across India with all key details upfront like material type, quantity, grade, location, and deadlines.
          </p>
          <p>
            Countdown timers and smart filters like "Expiring Soon" or "High Volume" help you act quickly.
          </p>
        </div>

        {/* Right Column: Image */}
        <div className="tender-access-image-col">
          <img src={tenderImage} alt="Detailed tender information interface" />
        </div>
      </div>
    </section>
  );
};

export default TenderAccess;